/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p[_ngcontent-%COMP%]{text-align:center;font-weight:700;font-size:1.1rem;margin-top:10px;margin-bottom:30px}"];
export { styles as styles };
